module.exports = __webpack_public_path__ + "img/bigBlueArrow.5e73b98b.svg";